import React, { Component } from 'react'

class Todo6 extends Component {
    
  render() {
    return (
      <>
      <br/>
        <h1>todo6</h1>
      </>
    )
  }
}

export default Todo6;
